import { Stack } from '@chakra-ui/react'

const HistoryCard = ( props ) => {

  return(
    <>
      <Stack direction='row' spacing={3}>
        <div className = "text-4xl text-[#a30b0b] font-bold w-40">{props.history.year}</div>
        <div className = "text-4xl font-medium w-full">{props.history.content}</div>
      </Stack>
    </>
  )
}

export default HistoryCard